import Vue from 'vue'
import Router from 'vue-router'

import authRoutes from '@/views/auth/router';
import advertsRoutes from '@/views/adverts/router';
import clientsRoutes from '@/views/clients/router';
import androidRoutes from '@/views/android/router';

import Demo from '@/views/Demo';

Vue.use(Router);

export default new Router({
    linkActiveClass: 'open active',
    routes: [
        // Demo
        {
            path: '/demo',
            name: 'Demo',
            component: Demo,
        },
        {
            path: '/ads/:company?',
            name: 'Ads',
            component: Demo
        },
        {
            path: '/',
            redirect: '/hub'
        },
        // Hub
        {
            path: '/hub',
            name: 'Hub',
            component: () => import ('@/views/Hub')
        },
        // Users
        {
            path: '/users',
            name: 'Users',
            component: () => import ('@/views/Users')
        },
        // Companies
        {
            path: '/companies',
            name: 'Companies',
            component: () => import ('@/views/Companies')
        },
        ...androidRoutes,
        ...advertsRoutes,
        ...clientsRoutes,
        ...authRoutes
    ]
})
